// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdminCreateCohort_wrapper"};